import { ContentStateInterface, GeoCoordinates, LocationMapGeolocation } from '../../@types/types'

const DEFAULT_ZOOM = 11
const DEFAULT_LATITUDE = 52.51 // BERLIN
const DEFAULT_LONGITUDE = 13.4 // BERLIN

export const getGeolocation = (
  geoCoordinates: GeoCoordinates,
  insertionData: ContentStateInterface
): LocationMapGeolocation => {
  const isManual = geoCoordinates.latitude === 0 && geoCoordinates.longitude === 0
  if (geoCoordinates.longitude !== 0 && geoCoordinates.latitude !== 0) {
    return { isManual, latitude: geoCoordinates.latitude, longitude: geoCoordinates.longitude }
  }
  if (insertionData.manualQuarter?.geoCoordinates) {
    const { longitude, latitude } = insertionData.manualQuarter.geoCoordinates
    return { isManual, latitude, longitude }
  }
  return { isManual, latitude: DEFAULT_LATITUDE, longitude: DEFAULT_LONGITUDE }
}

export const calculateZoom = (insertionData: ContentStateInterface, isManual: boolean): number => {
  if (isManual) {
    return getZoomForManual(insertionData.hideStreetAndStreetNumber ?? false)
  } else {
    return getZoom(
      insertionData.hideStreetAndStreetNumber ?? false,
      insertionData.city as string | undefined,
      insertionData.street,
      insertionData.postcode
    )
  }
}

const getZoomForManual = (hideStreetAndStreetNumber: boolean): number => {
  if (hideStreetAndStreetNumber) {
    return 15
  } else {
    return 12
  }
}

const getZoom = (hideStreetAndStreetNumber: boolean, city?: string, street?: string, postcode?: string): number => {
  let zoom = DEFAULT_ZOOM
  if (city && street) {
    zoom = 16
  }
  if ((city || postcode) && hideStreetAndStreetNumber) {
    zoom = 13
  }

  return zoom
}
